module.exports = __webpack_public_path__ + "fonts/Roboto-300-cyrillic-ext22.3004e52.woff2";